// S ::: 180x180 시간표 담당강사 용 작은 이미지 ::: S
import VLAZESmallImage from "../assets/images/smallLogo/small-vlaze.png";
import WARISmallImage from "../assets/images/smallLogo/small-whatdowwari.png";

import BUMBLEBSmallImage from "../assets/images/smallLogo/small-bumbleb.png";
import EUNHYESmallImage from "../assets/images/smallLogo/small-eunhye.png";
import BOOBISmallImage from "../assets/images/smallLogo/small-boobi.png";

import HONEYBEESmallImage from "../assets/images/smallLogo/small-honeybee.png";
import KYURISmallImage from "../assets/images/smallLogo/small-kyuri.png";
import WannoSmallImage from "../assets/images/smallLogo/small-wanno.png";
import JAEHUNSmallImage from "../assets/images/smallLogo/small-jaehun.png";
// E ::: 180x180 시간표 담당강사 용 작은 이미지 ::: E

// S ::::: 스케쥴 ::::: S
export const scheduleList = [
  {
    dayEn: "MON",
    dayKo: "월",
    class: [
      {
        time: "7:00 PM",
        title: "셔플 Level.1",
        instructor: "KYU RI",
      },
      {
        time: "8:00 PM",
        title: "힙합 비기너",
        instructor: "BUMBLE.B",
      },
      {
        time: "9:00 PM",
        title: "힙합 레벨업",
        instructor: "BUMBLE.B",
      },
    ],
  },
  // {
  //   dayEn: "TUE",
  //   dayKo: "화",
  //   class: [
  //     {
  //       time: "11:00 AM",
  //       title: "셔플 Level.1",
  //       instructor: "EUN HYE",
  //     },
  //     {
  //       time: "",
  //       title: "PRIVATE LESSON",
  //       instructor: "",
  //     },
  //   ],
  // },
  {
    dayEn: "WED ",
    dayKo: "수",
    class: [
      {
        time: "2:00 PM",
        title: "시니어 셔플",
        instructor: "",
      },
      {
        time: "7:00 PM",
        title: "셔플 Level.2",
        instructor: "EUN HYE",
      },

      {
        time: "8:00 PM",
        title: "셔플 Level.3",
        instructor: "EUN HYE",
      },
    ],
  },
  {
    dayEn: "THU",
    dayKo: "목",
    class: [
      {
        time: "7:00 PM",
        title: "셔플&풋워크 Level.4",
        instructor: "VLAZE",
      },
      {
        time: "8:00 PM",
        title: "풋워크 테크닉",
        instructor: "VLAZE",
      },
      {
        time: "9:00 PM",
        title: "레트로 케이팝",
        instructor: "KYURI",
      },
    ],
  },
  {
    dayEn: "SAT",
    dayKo: "토",
    class: [
      {
        time: "10:00 AM",
        title: "셔플 Level.1",
        instructor: "EUN HYE",
      },
      {
        time: "11:00 AM",
        title: "셔플&풋워크 Level.4",
        instructor: "VLAZE",
      },
      {
        time: "12:00 PM",
        title: "셔플 Level.2",
        instructor: "EUN HYE",
      },

      {
        time: "1:00 PM",
        title: "셔플&풋워크 Level.3",
        instructor: "VLAZE",
      },
      {
        time: "2:00 PM",
        title: "힙합 비기너",
        instructor: "EUN HYE",
      },
      {
        time: "3:00 PM",
        title: "하우스 비기너",
        instructor: "JAE HUN",
      },
    ],
  },
  {
    dayEn: "SUN",
    dayKo: "일",
    class: [
      {
        time: "10:00 AM",
        title: "키즈 풋워크 비기너",
        instructor: "",
      },
      {
        time: "11:00 AM",
        title: "셔플&풋워크 Level.4",
        instructor: "VLAZE",
      },
      {
        time: "12:00 PM",
        title: "키즈 풋워크 프로",
        instructor: "HONEYBEE",
      },
      {
        time: "1:00 PM",
        title: "셔플&풋워크 Level.3",
        instructor: "VLAZE",
      },
    ],
  },
];
// E ::::: 스케쥴 ::::: E

// S ::::: 셔플 스케쥴 ::::: S
export const shuffleScheduleList = [
  {
    dayEn: "LEVEL.1",
    dayKo: "입문",
    class: [
      {
        time: "",
        title: "월 MON 7:00 PM",
        instructor: "KYU RI",
      },

      {
        time: "",
        title: "토 SAT 10:00 AM",
        instructor: "EUN HYE",
      },
    ],
  },
  {
    dayEn: "LEVEL.2",
    dayKo: "초급",
    class: [
      {
        time: "",
        title: "수 WED 7:00 PM",
        instructor: "EUN HYE",
      },
      {
        time: "",
        title: "토 SAT 12:00 PM",
        instructor: "EUN HYE",
      },
    ],
  },
  {
    dayEn: "LEVEL.3",
    dayKo: "중급",
    class: [
      {
        time: "",
        title: "토 SAT 1:00 PM",
        instructor: "VLAZE",
      },
      {
        time: "",
        title: "일 SUN 1:00 PM",
        instructor: "VLAZE",
      },
    ],
  },
  {
    dayEn: "LEVEL.4",
    dayKo: "마스터",
    class: [
      {
        time: "",
        title: "목 THU 7:00 PM",
        instructor: "VLAZE",
      },
      {
        time: "",
        title: "토 SAT 11:00 AM",
        instructor: "VLAZE",
      },
      {
        time: "",
        title: "일 SUN 11:00 AM",
        instructor: "VLAZE",
      },
    ],
  },
  {
    dayEn: "FOOTWORK TECHNIQUE",
    dayKo: "풋워크 테크닉",
    class: [
      {
        time: "",
        title: "목 THU 8:00 PM",
        instructor: "VLAZE",
      },
    ],
  },
  {
    dayEn: "KIDS",
    dayKo: "키즈 풋워크",
    class: [
      {
        time: "",
        title: "일 SUN 10:00 AM 비기너",
        instructor: "",
      },
      {
        time: "",
        title: "일 SUN 12:00 PM 프로",
        instructor: "HONEYBEE",
      },
    ],
  },
];
// E ::::: 셔플 스케쥴 ::::: E

// S ::: 스케쥴 강사 리스트 ::: S
export const scheduleInstructorsList = [
  {
    name: "VLAZE",
    smallImg: VLAZESmallImage,
  },

  {
    name: "WHATDOWWARI",
    smallImg: WARISmallImage,
  },

  {
    name: "EUN HYE",
    smallImg: EUNHYESmallImage,
  },

  {
    name: "BUMBLE.B",
    smallImg: BUMBLEBSmallImage,
  },

  {
    name: "HONEYBEE",
    smallImg: HONEYBEESmallImage,
  },
  {
    name: "WAANO",
    smallImg: WannoSmallImage,
  },

  // {
  //   name: "ONE",
  //   smallImg: ONESmallImage,
  // },
  {
    name: "KYURI",
    smallImg: KYURISmallImage,
  },

  {
    name: "BOOBI",
    smallImg: BOOBISmallImage,
  },
  {
    name: "JAE HUN",
    smallImg: JAEHUNSmallImage,
  },
];
